import React, { useState, useEffect } from 'react';
import DataGridComp from '../../../Core/Grid';
import { Grid, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import { Backup } from '@material-ui/icons';
import { SecondaryButton } from '../../../Core/FormInput';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb/index';
import { getStamps_List } from '../../../Core/Service/stamp-screen-service';
import StampUploadModal from './StampUploadModal';
import '../commonStyle.scss';
import DialogComp from '../../../Core/Controls/Dialog/DialogComp';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Stamps', active: true }
];

const styles = {
    gridImage: {
        width: 100, 
        height: 'auto',
        maxHeight: 130, 
        objectFit: 'contain'
    },
    gridImageContainer: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        justifyContent: 'flex-start'
    }
};

function Stamps(props) {
    const [state, setState] = useState({
        stampsList: [],
        loader: true,
    });

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedStamp, setSelectedStamp] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(false);

    useEffect(() => {
        const pullData = async () => {
            try {
                setState(prev => ({ ...prev, loader: true }));
                const res = await getStamps_List();
                const stampsWithIds = res.data.details.map((stamp) => ({
                    ...stamp,
                    id: stamp.stampID
                }));
                setState(prev => ({
                    ...prev,
                    stampsList: stampsWithIds || [],
                    loader: false
                }));
            } catch (error) {
                console.error('Error fetching stamps:', error);
                setState(prev => ({ ...prev, loader: false }));
            }
        };
        pullData();
    }, [refreshTrigger]);

    const ActionButtons = (params) => {
        return (
            <Tooltip title="Update Stamp" aria-label="add">
                <IconButton 
                    size="small" 
                    style={{ alignItems: 'center', justifyContent: 'center' }} 
                    onClick={() => {
                        setSelectedStamp(params.row);
                        setModalOpen(true); 
                    }}
                >
                    <Backup color="secondary" />
                </IconButton>
            </Tooltip>
        );
    };

    const StampImageRenderer = (params) => {
        if (!params.value) {
            return <div style={styles.gridImageContainer}>No Image</div>;
        }
        return (
            <div style={styles.gridImageContainer}>
                <img
                    src={params.value}
                    alt="Stamp"
                    style={styles.gridImage}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.alt = 'Image failed to load';
                    }}
                />
            </div>
        );
    };

    const columns = [
        {
            field: 'actions',
            headerName: 'Action',
            sortable: false,
            width: 100,
            renderCell: (params) => <ActionButtons {...params} />
        },
        {
            field: 'stampImage',
            headerName: 'Stamp Image',
            flex: 2,
            renderCell: StampImageRenderer,
            headerAlign: 'left',
            align: 'left'
        }
    ];

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedStamp(null);
    };

    return (
        <div className="screen">
            <Grid item container justify="space-between">
                <Grid item>
                    <BreadCrumbs crumbs={crumbs} />
                </Grid>
                <Grid item style={{ marginTop: '15px' }}>
                    <SecondaryButton 
                        variant="contained" 
                        color="secondary" 
                        className="btnadd" 
                        onClick={() => setModalOpen(true)}
                    >
                        Add Stamp
                    </SecondaryButton>
                </Grid>
            </Grid>
            
            {state.loader ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <CircularProgress />
                </div>
            ) : (
                <DataGridComp
                    columns={columns}
                    rows={state.stampsList}
                    headerHeight={40}
                    rowHeight={80}
                    isRowHovered={true}
                    loadingData={state.loader}
                    offset={260}
                />
            )}

            {modalOpen && (
                <DialogComp 
                    title={selectedStamp ? "Manage Stamp" : "Add New Stamp"}
                    maxWidth="md"
                    fullWidth
                    onClose={handleCloseModal}
                >
                    <StampUploadModal 
                        id={selectedStamp}
                        onClose={(shouldRefresh) => {
                            if (shouldRefresh) setRefreshTrigger(prev => !prev);
                            handleCloseModal();
                        }}
                    />
                </DialogComp>
            )}
        </div>
    );
}
export default Stamps;